export default __webpack_public_path__ + "static/media/remove.0476d35e.svg";